import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProjectByIdAction } from '../../../utils/redux/project/projectActions';
import { fetchBoardsByProjectAction } from '../../../utils/redux/projectBoard/projectBoardActions';
import { FiArrowLeft, FiEdit2, FiPlus } from 'react-icons/fi';
import styles from './ProjectDetails.module.css';

const ProjectDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedProject: project, isLoading } = useSelector(state => state.project);
    const { boards } = useSelector(state => state.projectBoard);

    useEffect(() => {
        if (id) {
            dispatch(fetchProjectByIdAction(id));
            dispatch(fetchBoardsByProjectAction(id));
        }
    }, [dispatch, id]);

    const handleGoBack = () => {
        navigate('/projects');
    };

    const handleEdit = () => {
        navigate(`/projects/${id}/edit`);
    };

    if (isLoading && !project) {
        return <div className={styles.loading}>Loading...</div>;
    }

    if (!project) {
        return <div className={styles.error}>Project not found</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <button onClick={handleGoBack} className={styles.backButton}>
                    <FiArrowLeft size={20} /> Back
                </button>
            </div>

            <div className={styles.content}>
                <div className={styles.infoSection}>
                    <h1 className={styles.title}>{project.name}</h1>
                    <div className={styles.infoGrid}>
                        <div className={styles.infoItem}>
                            <label>Project Code:</label>
                            <span>{project.project_code || 'N/A'}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <label>Status:</label>
                            <span>{project.status}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <label>Owner:</label>
                            <span>{project.owner?.first_name} {project.owner?.last_name}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <label>Location:</label>
                            <span>{project.location || 'N/A'}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <label>Created At:</label>
                            <span>{new Date(project.createdAt).toLocaleDateString()}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <label>Last Updated:</label>
                            <span>{new Date(project.updatedAt).toLocaleDateString()}</span>
                        </div>
                    </div>
                </div>

                <div className={styles.boardsSection}>

                    {boards.length === 0 ? (
                        <div className={styles.noBoards}>
                            <p>No boards created yet.</p>
                        </div>
                    ) : (
                        <div className={styles.boardsList}>
                            {boards.map((board, index) => (
                                <Link to={`/project-board/${board._id}`} key={board._id} className={styles.boardCard}>
                                    <div className={styles.boardInfo}>
                                        <span className={styles.boardNumber}>{index + 1}</span>
                                        <div>
                                            <h3 className={styles.boardName}>{board.name}</h3>
                                            <p className={styles.boardMeta}>Created: {new Date(board.createdAt).toLocaleDateString()}</p>
                                        </div>
                                    </div>
                                    <div className={styles.boardStatus}>
                                        {board.isApproved ? (
                                            <span className={styles.approvedBadge}>Approved</span>
                                        ) : (
                                            <span className={styles.pendingBadge}>Pending</span>
                                        )}
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProjectDetails;